//////////////// Simple tabs in jquery
export default function() {
    $('[data-tab-group]').on('click', '[data-tab-target]', function(){
        const $tabTarget = $(this);
        const target = $tabTarget.attr('data-tab-target');
        const $tabGroup = $(this).parents('[data-tab-group]');
        const $tabContent = $(`[data-tab-content="${target}"]`);

        if(!$tabContent.length || !$tabGroup.length) return;

        $tabGroup.find('.current').removeClass('current');
        $tabTarget.addClass('current');
        $tabContent.addClass('current');
    });
};
